var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UserTree",style:(_vm.userStyle)},[_c('VirtualTree',{ref:"virtualTreeRef",attrs:{"emptyText":_vm.emptyText,"data":_vm.userTreeData,"defaultExpandAll":_vm.defaultExpandAll,"showCheckbox":_vm.showCheckbox,"fieldNames":{
      key:'userId',
      parentKey:'parentId',
      label:'corpName'
    }},on:{"node-click":_vm.onNodeClick,"check-change":_vm.onCheckChange},scopedSlots:_vm._u([{key:"default",fn:function({node}){return [_c('div',{staticClass:"UserNode"},[_c('UserAvator'),_vm._v(" "+_vm._s(node.corpName)+" "),(_vm.$scopedSlots.action)?_c('label',[_vm._t("action",null,{"node":node})],2):_vm._e()],1)]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }